import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { SidedrawerService } from '../../../sidedrawer/services/sidedrawer.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { DictionaryGlobalStore } from '../../../dictionary/store/dictionary-global.store';
import {
  catchError,
  exhaustMap,
  filter,
  take,
  tap,
  timeout,
} from 'rxjs/operators';
import { Locale } from '../../../dictionary/models/locale.model';
import { HttpErrorResponse } from '@angular/common/http';
import { SfAuthActions } from '../core/store/sf-auth.store';
import { Observable, of } from 'rxjs';
import { SetActiveSideDrawer } from '../../../sidedrawer/store/sidedrawer.actions';
import { SideDrawer } from '../../../sidedrawer/models/side-drawer.model';

export const sfSideDrawerResolver: ResolveFn<SideDrawer> = (
  route,
  state,
  sideDrawerService = inject(SidedrawerService),
  store: Store<AppState> = inject(Store<AppState>),
  dictStore = inject(DictionaryGlobalStore)
): Observable<SideDrawer> => {
  const { sideDrawerId } = route.params;
  return toObservable(dictStore.localeDefault).pipe(
    filter(locale => locale !== null),
    take(1),
    timeout(10000),
    exhaustMap(locale =>
      sideDrawerService
        .getSideDrawerHomeLite(sideDrawerId, Locale.getLocaleId(locale))
        .pipe(
          catchError((error: HttpErrorResponse) => {
            store.dispatch(
              SfAuthActions.generalErrorModeUpdated({
                generalErrorMode:
                  error.status === 404
                    ? '404'
                    : error.status === 403 || error.status === 401
                      ? '403'
                      : 'generic',
              })
            );
            return of(null);
          }),
          tap(sideDrawer =>
            store.dispatch(new SetActiveSideDrawer({ data: sideDrawer }))
          )
        )
    ),
    catchError(() => {
      store.dispatch(
        SfAuthActions.generalErrorModeUpdated({ generalErrorMode: 'generic' })
      );
      return of(null);
    })
  );
};
